// Các chức năng trong thông báo
export default {
  /**
   * Xem chi tiết
   */
  ViewDetail: 1,
  /**
   * Đối chiếu dữ liệu convert
   */
  CompareConvertData: 2,
};
